import { getQueryParam, setQueryParam } from '../../../assets/js/queryParams';

const tabWidgetClassName = 'js-tab-panel-widget';
const tabsContainerClassName = 'js-tpw-tabs-container';
const tabsScrollContainerClassName = 'js-tpw-tabs-scroll-container';
const tabClassName = 'js-tpw-tab-button';
const panelClassName = 'js-tpw-panel';

const activeTabQP = 'activeTab';

const tabWidgets = document.querySelectorAll(`.${tabWidgetClassName}`);

tabWidgets.forEach((tabWidget, tabWidgetIndex) => {
  initializeTabWidget(tabWidget, tabWidgetIndex);
});

function initializeTabWidget(tabWidget, tabWidgetIndex) {
  let isMobile = checkIsMobile();

  const tabsContainer = tabWidget.querySelector(`.${tabsContainerClassName}`);
  const tabsScrollContainer = tabWidget.querySelector(`.${tabsScrollContainerClassName}`);
  const tabs = tabWidget.querySelectorAll(`.${tabClassName}`);
  const panels = tabWidget.querySelectorAll(`.${panelClassName}`);

  let swiper = new Swiper(tabsScrollContainer, {
    init: isMobile,
    width: 'auto',
    slidesPerView: 'auto',
    spaceBetween: 24,
    on: {
      slideChange: ({ snapIndex }) => handleScrollShadowVisibility(tabsContainer, tabs, snapIndex),
    },
  });

  handleScrollShadowVisibility(tabsContainer, tabs, swiper.activeIndex);

  window.addEventListener('resize', () => {
    const prevIsMobile = isMobile;
    isMobile = checkIsMobile();

    if (!prevIsMobile && isMobile) {
      swiper.init();
    } else if (prevIsMobile && !isMobile) {
      swiper.destroy(false);
    }
  });

  tabs.forEach((tab, tabIndex) => {
    tab.addEventListener('click', () => {
      const isAlreadyOpen = tab.getAttribute('aria-expanded') === 'true';
      if (isAlreadyOpen) {
        return;
      }

      openTab(tabs, panels, tabIndex);
      setQueryParam(`${activeTabQP}-${tabWidgetIndex}`, tabIndex);

      if (checkIsMobile()) {
        swiper.slideTo(tabIndex);
      }
    });
  });

  const activeTab = getQueryParam(`${activeTabQP}-${tabWidgetIndex}`);
  if (activeTab) {
    scrollToTabContainer(tabsScrollContainer);
    openTab(tabs, panels, activeTab);
  } else {
    openTab(tabs, panels, 0);
  }
}

function scrollToTabContainer(tabsScrollContainer, yOffset = 50) {
  const { top } = tabsScrollContainer.getBoundingClientRect();
  const scrollToY = top + window.scrollY - yOffset;

  window.scrollTo({ top: scrollToY, behavior: 'smooth' });
}

function checkIsMobile() {
  return window.matchMedia('(max-width: 767px)').matches;
}

function openTab(tabs, panels, tabIndex) {
  tabs.forEach((tab) => {
    const isActiveTab = tab.getAttribute('aria-controls').endsWith(`_${tabIndex}`);

    tab.setAttribute('aria-expanded', isActiveTab ? 'true' : 'false');
  });

  panels.forEach((panel) => {
    const isActivePanel = panel.id.endsWith(`_${tabIndex}`);

    if (isActivePanel) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  });
}

function handleScrollShadowVisibility(tabsContainer, tabs, tabIndex) {
  const leftShadowClassName = 'tpw__tabs-container--with-left-shadow';
  const rightShadowClassName = 'tpw__tabs-container--with-right-shadow';

  if (tabIndex > 0) {
    tabsContainer.classList.add(leftShadowClassName);
  } else {
    tabsContainer.classList.remove(leftShadowClassName);
  }

  if (tabIndex < tabs.length - 1) {
    tabsContainer.classList.add(rightShadowClassName);
  } else {
    tabsContainer.classList.remove(rightShadowClassName);
  }
}
